import { Directive, HostListener, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../shared/services/common.service';
import { NotificationType } from '../enums/notification-types.enum';

@Directive({
    selector: '[copyToClipboard]'
})

export class CopyToClipboardDirective {
    constructor(private _translatePipe: TranslateService,
        private _commonService: CommonService) {

    }
    @Input() copyToClipboard: string | any;
    @HostListener('click', ['$event'])
    onclickEvent() {
        if (this.copyToClipboard && this.copyToClipboard != null) {
            const event = (e: ClipboardEvent) => {
                e.clipboardData.setData('text/plain', this.copyToClipboard);
                e.preventDefault();
            }
            document.addEventListener('copy', event);
            if (document.execCommand('copy')) {
                const notification: any = this._translatePipe.get('customer-service.Copied to clipboard');
                this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
            }
            else {
                const notification: any = this._translatePipe.get('customer-service.Not copied to clipboard');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
            document.removeEventListener('copy', event);
        }
        else {
            const notification: any = this._translatePipe.get('customer-service.Not copied to clipboard');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/directive/copy-to-clipboard.directive.ts